import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#process", label: "Process" },
  { href: "#clients", label: "Clients" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-3 sm:top-4 left-1/2 -translate-x-1/2 z-50 w-[94%] max-w-6xl transition-all duration-500 ${
        scrolled ? "scale-[0.985]" : "scale-100"
      }`}
    >
      <nav
        className={`glass-strong rounded-full flex items-center justify-between px-4 sm:px-6 py-3 sm:py-3.5 ${
          scrolled ? "shadow-[0_8px_40px_rgba(0,122,255,0.15)]" : ""
        }`}
      >
        <a
          href="#top"
          data-testid="navbar-brand"
          className="flex items-center gap-2 group"
        >
          <span className="relative h-7 w-7 grid place-items-center rounded-full bg-[#007AFF]/20 border border-[#007AFF]/40">
            <span className="h-2 w-2 rounded-full bg-[#00F0FF] animate-pulse-glow" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight">
            Brand<span className="text-[#00F0FF]">With</span>Abdo
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                href={l.href}
                className="text-sm text-slate-300 hover:text-white transition-colors duration-200"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          data-testid="navbar-cta"
          className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold pl-4 pr-1.5 py-1.5 rounded-full bg-white text-black hover:bg-[#00F0FF] transition-colors"
        >
          Book a call
          <span className="grid place-items-center h-7 w-7 rounded-full bg-black text-white">
            <ArrowUpRight className="h-3.5 w-3.5" />
          </span>
        </a>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden grid place-items-center h-9 w-9 rounded-full bg-white/5 border border-white/10"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden mt-2 glass-strong rounded-3xl p-4 flex flex-col gap-1"
        >
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 text-slate-200 hover:bg-white/5 rounded-xl"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="mobile-nav-cta"
            onClick={() => setOpen(false)}
            className="mt-1 inline-flex items-center justify-center gap-1.5 text-sm font-semibold px-4 py-2.5 rounded-full bg-white text-black"
          >
            Book a free consultation <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      )}
    </header>
  );
}
